import { render, staticRenderFns } from "./ProjectsTableComponent.vue?vue&type=template&id=44725280&"
import script from "./ProjectsTableComponent.vue?vue&type=script&lang=js&"
export * from "./ProjectsTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports